var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",attrs:{"id":"infinite-list"}},_vm._l((_vm.changeData(
                _vm.listCallCenterBooking,
                _vm.invalidBooking
            )),function(item,i){return _c('card-call-center',{key:i,attrs:{"data-booking":item}})}),1),(_vm.loadMore)?_c('div',{staticClass:"col-md-12 text-center p-3"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"spinner-grow"}),_c('p',[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }